import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UserService} from './services/user.service';
import {AdminService} from '../../../services/admin.service';
import {ConstantsService} from '../../../services/constants.service';
import {UrlService} from '../../../services/url.service';
import {User} from '../../../types/admin-data.types';
import {IToastr} from '../../../types/toastr';
import {flatMap, takeUntil} from 'rxjs/operators';
import {AccountPermissionsService} from '../../../services/account-permissions.service';

declare const swal;
declare const toastr: IToastr;

@Component({
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, OnDestroy {
    public isModalShow: boolean = false;
    public isHistoryModalShow: boolean = false;
    public modalType: string;
    public currentItemData = {};
    public isEditNameModalShow: boolean = false;

    private currentUser: any = {};

    constructor(
        public urlService: UrlService,
        public userService: UserService,
        private accountPermissionsService: AccountPermissionsService,
        public adm: AdminService) {
    }

    ngOnInit() {
        this.userService.account.navigateIfServiceDisallowed('auth', '/home');
        this.userService.urlService
            .onUrlChange
            .pipe(
                flatMap(
                    () => this.userService.getByUrlQueryParams().pipe(
                        takeUntil(this.urlService.instantOnUrlChange)
                    )
                ),
            )
            .subscribe();
        this.userService.urlService.setQueryParams('user');
        this.userService.getUserRoles();
        this.userService.getCompanies();
        this.userService.getCorporationNumber();

        this.currentUser = this.userService.account.user;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.userService.emptyRowService.fillEmptyRow();
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.userService.urlService.resetQueryParams();
        this.userService.data = [];
    }

    removeAllObservers() {
        this.userService.urlService.onUrlChange.observers = [];
    }

    openCreateNew() {
        this.modalType = 'create';
        this.isModalShow = true;
        this.currentItemData = {
            phones: [],
            email: '',
            sendInvitationEmail: false,
            userType: 'property_manager',
            company: this.userService.account.user.company ? this.userService.account.user.company : {}
        };
    }

    openUpdate(itemData) {
        this.modalType = 'edit';
        this.isModalShow = true;
        this.currentItemData = itemData;
    }

    openHistoryModal(itemData) {
        this.isHistoryModalShow = true;
        this.currentItemData = itemData;
    }

    resendInvitation(itemData) {
        swal(ConstantsService.getSwalConfig('Send Invitation?', 'Do you want to send invitation email to user?'),
            () => this.userService.resendInvitation(itemData)
        );
    }

    sendInvitation(itemData) {
        swal(ConstantsService.getSwalConfig('Send Invitation?', 'Do you want to send invitation email to user?'),
            () => this.userService.sendInvitation(itemData)
        );
    }

    resetPassword(userData) {
        this.userService.showUserPasswordResetModal = true;
        this.userService.userInResetPasswordModal = userData;
    }

    closeHistoryModal() {
        this.isHistoryModalShow = false;
        this.currentItemData = {};
        this.urlService.modalClosed.emit();
    }

    closeModal() {
        this.isModalShow = false;
        this.isEditNameModalShow = false;
        this.urlService.modalClosed.emit();
    }

    onActionClick(e) {
        switch (e.type) {
            case 'remove':
                if (e.data.suiteUsers.length < 2) {
                    this.userService.remove(e.data.id);
                } else {
                    this.userService.showDeletePopup(e.data);
                }
                break;
            case 'edit':
                this.openUpdate(e.data);
                break;
            case 'history':
                this.openHistoryModal(e.data);
                break;
            case 'sendInvitation':
                this.sendInvitation(e.data);
                break;
            case 'resendInvitation':
                this.resendInvitation(e.data);
                break;
            case 'resetPassword':
                this.resetPassword(e.data);
                break;
            case 'toggleUserLock':
                this.toggleUserLock(e.data);
                break;
            case 'editName':
                this.openEditName(e.data);
                break;
            case 'residentToStaff':
                this.residentToStaff(e.data);
                break;
            case 'loginAsUser':
                this.loginAsUser(e.data);
                break;
            default:
                break;
        }
    }

    loginAsUser(user: User): void {
        this.userService.loginAsUser(user.email).subscribe();
    }

    getUserTypeName(key) {
        return this.userService.userTypes.find(type => type.id === key).name;
    }

    openEditName(itemData) {
        this.isEditNameModalShow = true;
        this.currentItemData = itemData;
    }

    residentToStaff(user: Partial<User>): void {
        // if (this.currentUser.userType !== 'property_manager') {
        //     toastr.error('Forbidden!');
        //     return;
        // }
        // const corporationNumberPropertyManager = this.currentUser.corporationNumberPropertyManager
        //     .map(row => {
        //         return {
        //             corporationNumber: row.corporationNumber,
        //             corporationNumberBdId: row.corporationNumberBdId
        //         };
        //     });
        //
        // const buildingPropertyManager = this.currentUser.buildingPropertyManager
        //     .filter(row => row.role && row.role.id)
        //     .map(row => {
        //         return {
        //             buildingId: row.buildingId,
        //             role: row.role.id
        //         }
        //     });
        //
        // const data: Partial<User> = {
        //     company: this.currentUser.company.id,
        //     buildingPropertyManager: buildingPropertyManager,
        //     corporationNumberPropertyManager: corporationNumberPropertyManager,
        //     userType: 'property_manager'
        // };
        //
        // this.userService.update(user.id, data).subscribe(res => {
        //     toastr.success('User convert successfully!');
        //     this.userService.get();
        // });
        this.currentItemData = {
            ...user,
            company: {
                id: this.accountPermissionsService.isUserAdmin() ? undefined : this.accountPermissionsService.getUser().company.id
            },
            buildingPropertyManager: [],
            userType: 'property_manager',
            phones: []
        };
        this.modalType = 'toStaff';
        this.isModalShow = true;
    }

    toggleUserLock(user: User) {
        if (!this.accountPermissionsService.isUserCompanyAdmin() && !this.accountPermissionsService.isUserAdmin()) {
            toastr.error('Forbidden!');
            return;
        }
        this.userService.update(user.id, {
            // ...user,
            isLocked: !user.isLocked
        }).subscribe(() => {
            toastr.success(`User ${user.isLocked ? 'Unlocked' : 'Locked'} successfully!`);
            this.userService.get();
        });
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/admin/user/user.component.ts